// extracted by mini-css-extract-plugin
export default {"more__operations":"MoreMenu_more__operations__LpdH2","more__operations--visible":"MoreMenu_more__operations--visible__z54BT"};